import { ElementSchemaRegistry } from '@angular/compiler';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem, TreeNode } from 'primeng/api';
import { TreeModule } from 'primeng/tree';
import { finalize } from 'rxjs/operators';
import { LookupService } from '../../../services/lookups/lookup.service';
import { ReportcategoryDetailComponent } from './reportcategory-detail/reportcategory-detail.component';

@Component({
  selector: 'app-reportcategory',
  templateUrl: './reportcategory.component.html',
  styleUrls: ['./reportcategory.component.css']
})
export class ReportCategoryComponent implements OnInit {
  reportCategories: TreeNode[];
  items: MenuItem[];
  selectedNode: TreeNode;
  mdlDlgTitle:string;
  displayReportCategoryDlg:boolean;
  loading:boolean=false;
  @ViewChild(ReportcategoryDetailComponent) reportCategoryDetail :ReportcategoryDetailComponent;

  constructor(private lookupService: LookupService) { }

  ngOnInit() {
    this.items = [
      {label: 'Create Sub Category', icon: 'fa fa-plus-square', command: (event) => this.showReportCategoryDetailDlg("Create Sub Category",true)},
      {label: 'Modify Category', icon: 'fa fa-pencil-square', command: (event) => this.showReportCategoryDetailDlg("Modify  Category",false)}
  ];
    this.LoadReportCategoryHierarchy();
  }

  private LoadReportCategoryHierarchy() {
    this.loading =true;
    this.lookupService.getReportCategoryHierarchy$()
    .pipe(finalize(() => (this.loading = false)))
    .subscribe(data => {
      //console.log(Array.of(data));

      this.reportCategories = Array.of(data);
      this.reportCategories[0].expanded = true;
      this.reportCategories[0].children.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });
  }

  private showReportCategoryDetailDlg(title:string,isNew:boolean)
  {
    this.displayReportCategoryDlg = true;
    this.mdlDlgTitle =title;
    this.reportCategoryDetail.showReportCategoryDetail(parseInt(this.selectedNode.data),isNew);
  }
  
  ShowHideReportCategoryDetailDialog(isDisplay:boolean)
  {
    this.displayReportCategoryDlg = isDisplay;
    //TODO: Add behaviour subject in the services to manage refresh of the table.
    //this.LoadAllPosts();
    
  }
  RefreshDataSource(isReload:boolean)
  {
    if(isReload)
    this.LoadReportCategoryHierarchy();
  }
  onTreeContextMenuSelect(node, contextMenu) {
     if(node.data =="1")
     {
      this.items = [
        {label: 'Create Sub Category', icon: 'fa fa-plus-square', command: (event) => this.showReportCategoryDetailDlg("Create Sub Category",true)}];
        
     }
     else
     {
      this.items = [
        {label: 'Create Sub Category', icon: 'fa fa-plus-square', command: (event) => this.showReportCategoryDetailDlg("Create Sub Category",true)},
        {label: 'Modify Category', icon: 'fa fa-pencil-square', command: (event) => this.showReportCategoryDetailDlg("Modify  Category",false)}];
     }


  }

}
